import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_ABORT_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_POST_EMPLOYEES_IMPORTS_ABORT, KEY_POST_EMPLOYEES_IMPORTS_ABORT } from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_ABORT } from '../mocks';

type GenericPostConfirmImportedEmployees = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_ABORT_PATH_KEY
>;

type RequestEmployeesImportsAbort = GenericPostConfirmImportedEmployees['request']['path'];

export type CallParamsPostEmployeesImportsAbort = Omit<
  RequestEmployeesImportsAbort,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostEmployeesImportsAbort =
  GenericPostConfirmImportedEmployees['response']['body'];

type CallErrorPostEmployeesImportsAbort = GenericApiError;

type CallSelectorsPostEmployeesImportsAbort = unknown;

export const postEmployeesImportsAbortCall = createGeneralCall<
  CallParamsPostEmployeesImportsAbort,
  CallResponsePostEmployeesImportsAbort,
  CallErrorPostEmployeesImportsAbort,
  CallSelectorsPostEmployeesImportsAbort
>({
  id: KEY_POST_EMPLOYEES_IMPORTS_ABORT,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_EMPLOYEES_IMPORTS_ABORT(org as unknown as string, payload.jobId || '');
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED()
    ? (MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_ABORT as never)
    : (undefined as never),
});
